import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();
interface IsSupportContactPromptResponse {
  requiresSupport: boolean;
}

export const isSupportContactPrompt = async (
  term: string,
  httpClient: HttpClientFactory,
): Promise<boolean> => {
  try {
    fedopsLogger.interactionStarted('check-support-contact-prompt');
    const response = await httpClient
      .getInstance()
      .post<IsSupportContactPromptResponse>(clientTopology.isSupportContactUrl, { term });

    fedopsLogger.interactionEnded('check-support-contact-prompt');
    return response.data.requiresSupport;
  } catch (error) {
    logger.error({
      error,
      message: 'Failed to check if term is a support contact prompt',
      callParams: { term },
    });
    // Default to false if the request fails to not impact user experience
    return false;
  }
};
